import request from "../../untils/request.js"


export const recordOperationLog = (data) => {
    return request.post('/outpatient/log',data)
}